import { useState } from 'react';
import { ArFollowUpsView, COLLECTIONS, CreateLinkDrawer } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';

/**
 * Collections › Follow-ups (amendment 28 §2.2). The `/recall` list: switch, drag,
 * Report / Edit / Duplicate / Delete, Continue on a draft.
 */
export function CollectionsFollowUpsPage() {
  useClearPageTopBarActions();
  const navigate = useNavigate();
  const [linkOpen, setLinkOpen] = useState(false);

  return (
    <>
      <ArFollowUpsView
        onSelectTab={(tab) => {
          if (tab === 'balances') void navigate('/collections');
          else if (tab === 'links') void navigate('/collections/links');
        }}
        onOpenSettings={() => { void navigate('/settings/ai/accounts-receivable'); }}
        onCreateLink={() => { setLinkOpen(true); }}
        onNewFollowUp={() => { void navigate('/collections/follow-ups/new'); }}
        onReport={(id) => { void navigate(`/collections/follow-ups/${id}/edit`); }}
        onEdit={(id) => { void navigate(`/collections/follow-ups/${id}/edit`); }}
        onContinue={(id) => { void navigate(`/collections/follow-ups/${id}/edit`); }}
      />
      <CreateLinkDrawer open={linkOpen} patient={COLLECTIONS.drawerPatient} prefill={null} onClose={() => { setLinkOpen(false); }} />
    </>
  );
}
